let financial = {
  title: 'Financeiro',
  icon: 'mdi-finance',
  overview: {
    bills: 'Contas Pendentes',
    salary: 'Remunerações Pendentes'
  },
  cashflow: {
    title: 'Fluxo de Caixa',
    overview: {
      all: 'Todos',
      income: 'Receitas',
      payments: 'Pagamentos',
      unpaid: 'Pendentes',
      expenses: 'Despesas',
      profit: 'Lucro'
    },
    datatable: {
      search: 'Pesquisar',
      no_data: 'Nenhum resultado encontrado',
      no_results: 'Nenhum resultado encontrado',
      items_per_page: 'Lançamentos por página',
      headers: {
        id: '#ID',
        datetime: 'Data / Hora',
        date: 'Data',
        title: 'Título',
        description: 'Descrição',
        value: 'Valor',
        actions: 'Ações'
      }
    },
    actions: {
      view: 'Ver',
      new: 'Adicionar',
      edit: 'Editar',
      delete: 'Excluir',
      save: 'Salvar'
    },
    dialog: {
      delete: (title) => `Tem certeza que deseja excluir '${title}' ?`
    },
    new: {
      title: 'Adicionar Lançamento',
      form: {
        type: 'Tipo',
        date: 'Data do Pagamento',
        title: 'Título',
        value: 'Valor',
        method: 'Forma de Pagamento',
        parcels: 'Parcelas',
        taxes: 'Taxas',
        notes: 'Observações',
        advertise: (cat) => {
          let page = '',
              path = ''
          switch (cat) {
            case 1:
              page = 'Salários'
              path = 'Financeiro > Remunerações'
              break
            case 2:
              page = 'Contas'
              path = 'Financeiro > Contas'
              break
            case 3:
              page = 'Reposição de Estoque'
              path = 'Catálogo > Itens'
              break
            case 5:
              page = 'Comissões'
              path = 'Financeiro > Remunerações'
              break
          }
          return `Para maior facilidade em cadastrar/editar ${page}, favor utilizar via ${path}.`
        },
        rules: {
          title: [
            v => !!v || 'Título é obrigatório',
            v => (v && v.length <= 57) || 'O Título deve ter menos que 57 caracteres'
          ],
          value: [
            v => !!v && parseFloat(v.toString().match(/\d+/g).join([])) > 0 || 'O Valor deve ser maior que 0'
          ]
        }
      },
      types: {
        payment: 'Pagamento',
        expense: 'Despesa'
      },
      categories: {
        title: 'Categorias',
        title_s: 'Categoria',
        salary: 'Salários',
        comissions: 'Comissões',
        bills: 'Contas',
        stock: 'Reposição de Estoque',
        other: 'Outros'
      },
      meta: {
        add: 'Nova Linha'
      }
    },
    messages: {
      error: {
        not_found: 'Registro não encontrado'
      }
    }
  },
  periodicals: {
    title: 'Pagamentos Periódicos',
    title_s: 'Pag. Periódico',
    icon: 'mdi-progress-clock',
    datatable: {
      search: 'Pesquisar',
      no_data: 'Nenhum resultado encontrado',
      no_results: 'Nenhum resultado encontrado',
      items_per_page: 'Pagamentos por página',
      no_one: 'Nenhum',
      headers: {
        id: '#ID',
        period: 'Período',
        employee: 'Profissional',
        date: 'Dia',
        last_paid: 'Último Pago',
        next_due: 'Vencimento',
        title: 'Título',
        value: 'Valor',
        actions: 'Ações'
      }
    },
    actions: {
      edit: 'Editar',
      delete: 'Excluir'
    },
    dialog: {
      delete: (title) => `Tem certeza que deseja excluir '${title}' ?`
    },
    new: {
      title: 'Novo Pag. Periódico',
      edit: 'Editar Pag. Periódico',
      close: 'Fechar',
      save: 'Salvar',
      periods: {
        unknown: 'Desconhecido',
        monthly: 'Mensal',
        quarterly: 'Trimestral',
        semester: 'Semestral',
        annual: 'Anual',
        biannual: 'Bi-Anual'
      },
      rules: {
        employee: [
          v => !!v || 'Profissional é obrigatório'
        ],
        date: [
          v => !!v || 'Vencimento é obrigatório',
          v => (v && v > 0) || 'O Vencimento deve ser diferente de 0',
          v => (v && v <= 29) || 'O Vencimento deve ser menor que 29'
        ],
        title: [
          v => !!v || 'Título é obrigatório',
          v => (v && v.length <= 27) || 'O Título deve ter menos que 27 caracteres'
        ],
        value: [
          v => !!v && parseFloat(v.toString().match(/\d+/g).join([])) > 0 || 'O Valor deve ser maior que 0'
        ]
      }
    },
    messages: {
      error: {
        not_found: 'Pagamento Periódico não encontrado'
      }
    }
  },
  bills: {
    title: 'Contas',
    title_s: 'Conta',
    title_header: 'Pagamento de Contas',
    icon: 'mdi-file-document-multiple',
    datatable: {
      search: 'Pesquisar',
      no_data: 'Nenhum resultado encontrado',
      no_results: 'Nenhum resultado encontrado',
      items_per_page: 'Lançamentos por página',
      headers: {
        id: '#ID',
        datetime: 'Data / Hora',
        title: 'Título',
        bills: 'Contas',
        value: 'Valor',
        actions: 'Ações'
      }
    },
    dialog: {
      delete: (title) => `Tem certeza que deseja excluir '${title}' ?`
    },
    overview: {
      all: 'Todas',
      pending: 'Pendentes',
      paid: 'Pagas'
    },
    actions: {
      save: 'Salvar',
      new: 'Nova',
      edit: 'Editar'
    },
    new: {
      title: 'Pagar Contas',
    },
    widget: {
      periodicals: 'Periódicas',
      selected: 'Selecionadas',
      add: 'Adicionar Conta',
      form: {
        title: 'Título',
        reference: 'Referência',
        value: 'Valor',
        rules: {
          title: [
            v => !!v || 'Título é obrigatório',
            v => (v && v.length <= 27) || 'O Título deve ter menos que 27 caracteres'
          ],
          value: [
            v => !!v && parseFloat(v.toString().match(/\d+/g).join([])) > 0 || 'O Valor deve ser maior que 0'
          ]
        }
      }
    },
    edit: {
      title: 'Editar Pagamento'
    },
    messages: {
      error: {
        not_found: 'Pagamento não encontrado'
      }
    }
  },
  salary: {
    title: 'Remunerações',
    title_s: 'Remuneração',
    title_header: 'Pagamento de Salários',
    icon: 'mdi-account-tie',
    datatable: {
      search: 'Pesquisar',
      no_data: 'Nenhum resultado encontrado',
      no_results: 'Nenhum resultado encontrado',
      items_per_page: 'Lançamentos por página',
      headers: {
        id: '#ID',
        datetime: 'Data / Hora',
        title: 'Título',
        salary: 'Remunerações',
        value: 'Valor',
        actions: 'Ações'
      }
    },
    dialog: {
      delete: (title) => `Tem certeza que deseja excluir '${title}' ?`
    },
    overview: {
      all: 'Todas',
      pending: 'Pendentes',
      paid: 'Pagas'
    },
    actions: {
      save: 'Salvar',
      new: 'Nova',
      edit: 'Editar'
    },
    new: {
      title: 'Pagar Profissionais'
    },
    edit: {
      title: 'Editar Pagamento'
    },
    widget: {
      periodicals: 'Periódicas',
      comissions: 'Comissões',
      selected: 'Selecionadas',
      add: 'Adicionar Salário',
      filters: {
        prev: 'Semana Passada',
        next: 'Semana Seguinte',
      },
      view_order: 'Visualizar Pedido',
      empty: 'Nenhuma Comissão pendente para os filtros selecionados.',
      form: {
        title: 'Título',
        reference: 'Referência',
        value: 'Valor',
        rules: {
          title: [
            v => !!v || 'Título é obrigatório',
            v => (v && v.length <= 27) || 'O Título deve ter menos que 27 caracteres'
          ],
          value: [
            v => !!v && parseFloat(v.toString().match(/\d+/g).join([])) > 0 || 'O Valor deve ser maior que 0'
          ]
        }
      }
    },
    messages: {
      error: {
        not_found: 'Pagamento não encontrado'
      }
    }
  },
  reports: {
    title: 'Relatórios (EM CONSTRUÇÃO)'
  }
}

export default financial
